/* eslint-disable @typescript-eslint/no-explicit-any */

export const totalChartTest: any = {
  count: {
    se: {
      label: 'Sudeste',
      value: 143,
    },
    so: {
      label: 'Sul',
      value: 141,
    },
    total: {
      label: 'Total',
      value: 284,
    },
  },
  statesCount: {
    sp: {
      label: 'São Paulo',
      value: 141,
    },
    es: {
      label: 'Espírito Santo',
      value: 2,
    },
    rs: {
      label: 'Rio Grande do Sul',
      value: 141,
    },
  },
};

export const ageChartTest: any = {
  count: {
    br: {
      total: 200,
      values: [
        {
          label: 'Até 12 meses',
          value: 300,
        },
        {
          label: '13-24 meses',
          value: 323,
        },
        {
          label: '25-36 meses',
          value: 11,
        },
        {
          label: '37-48 meses',
        },
        {
          label: '49-60 meses',
        },
        {
          label: '+60 meses',
        },
      ],
    },
    se: {
      total: 200,
      values: [
        {
          label: 'Até 12 meses',
          value: 98,
        },
        {
          label: '13-24 meses',
          value: 32,
        },
        {
          label: '25-36 meses',
          value: 11,
        },
        {
          label: '37-48 meses',
        },
        {
          label: '49-60 meses',
        },
        {
          label: '+60 meses',
        },
      ],
    },
    so: {
      total: 200,
      values: [
        {
          label: 'Até 12 meses',
          value: 22,
        },
        {
          label: '13-24 meses',
          value: 11,
        },
        {
          label: '25-36 meses',
          value: 11,
        },
        {
          label: '37-48 meses',
        },
        {
          label: '49-60 meses',
        },
        {
          label: '+60 meses',
        },
      ],
    },
  },
  statesCount: {
    sp: {
      total: 200,
      values: [
        {
          label: 'Até 12 meses',
          value: 98,
        },
        {
          label: '13-24 meses',
          value: 32,
        },
        {
          label: '25-36 meses',
          value: 11,
        },
        {
          label: '37-48 meses',
        },
        {
          label: '49-60 meses',
        },
        {
          label: '+60 meses',
        },
      ],
    },
    es: {
      total: 200,
      values: [
        {
          label: 'Até 12 meses',
          value: 12,
        },
        {
          label: '13-24 meses',
          value: 14,
        },
        {
          label: '25-36 meses',
          value: 11,
        },
        {
          label: '37-48 meses',
        },
        {
          label: '49-60 meses',
        },
        {
          label: '+60 meses',
        },
      ],
    },
    rs: {
      total: 200,
      values: [
        {
          label: 'Até 12 meses',
          value: 12,
        },
        {
          label: '13-24 meses',
          value: 14,
        },
        {
          label: '25-36 meses',
          value: 11,
        },
        {
          label: '37-48 meses',
        },
        {
          label: '49-60 meses',
        },
        {
          label: '+60 meses',
        },
      ],
    },
  },
};

export const kmChartTest = {
  count: {
    br: {
      total: 232,
      values: [
        {
          label: '0-20 mil',
          value: 80,
        },
        {
          label: '20-50 mil',
          value: 1,
        },
        {
          label: '50-100 mil',
          value: 44,
        },
        {
          label: '+100 mil',
          value: 16,
        },
      ],
    },
    se: {
      total: 232,
      values: [
        {
          label: '0-20 mil',
          value: 80,
        },
        {
          label: '20-50 mil',
          value: 1,
        },
        {
          label: '50-100 mil',
          value: 44,
        },
        {
          label: '+100 mil',
          value: 16,
        },
      ],
    },
    so: {
      total: 232,
      values: [
        {
          label: '0-20 mil',
          value: 80,
        },
        {
          label: '20-50 mil',
          value: 1,
        },
        {
          label: '50-100 mil',
          value: 44,
        },
        {
          label: '+100 mil',
          value: 16,
        },
      ],
    },
  },
  statesCount: {
    sp: {
      total: 232,
      values: [
        {
          label: '0-20 mil',
          value: 80,
        },
        {
          label: '20-50 mil',
          value: 1,
        },
        {
          label: '50-100 mil',
          value: 44,
        },
        {
          label: '+100 mil',
          value: 16,
        },
      ],
    },
    es: {
      total: 232,
      values: [
        {
          label: '0-20 mil',
          value: 80,
        },
        {
          label: '20-50 mil',
          value: 1,
        },
        {
          label: '50-100 mil',
          value: 44,
        },
        {
          label: '+100 mil',
          value: 16,
        },
      ],
    },
    rs: {
      total: 232,
      values: [
        {
          label: '0-20 mil',
          value: 80,
        },
        {
          label: '20-50 mil',
          value: 1,
        },
        {
          label: '50-100 mil',
          value: 44,
        },
        {
          label: '+100 mil',
          value: 16,
        },
      ],
    },
  },
};

export const totalTableLabels = [
  {
    title: 'Placa',
    type: 'text',
    accessor: 'plate',
  },
  {
    title: 'Marca',
    type: 'text',
    accessor: 'brand',
  },
  {
    title: 'Modelo',
    type: 'text',
    accessor: 'model',
  },
  {
    title: 'Cor',
    type: 'text',
    accessor: 'color',
  },
  {
    title: 'Região',
    type: 'text',
    accessor: 'region',
  },
  {
    title: 'Cidade',
    type: 'text',
    accessor: 'city',
  },
  {
    title: 'Estado',
    type: 'text',
    accessor: 'uf',
  },
];

export const ageTableLabels = [
  {
    title: 'Placa',
    type: 'text',
    accessor: 'plate',
  },
  {
    title: 'Marca',
    type: 'text',
    accessor: 'brand',
  },
  {
    title: 'Modelo',
    type: 'text',
    accessor: 'model',
  },
  {
    title: 'Cor',
    type: 'text',
    accessor: 'color',
  },
  {
    title: 'Região',
    type: 'text',
    accessor: 'region',
  },
  {
    title: 'Cidade',
    type: 'text',
    accessor: 'city',
  },
  {
    title: 'Estado',
    type: 'text',
    accessor: 'uf',
  },
  {
    title: 'Idade',
    type: 'text',
    accessor: 'age',
  },
];

export const kmTableLabels = [
  {
    title: 'Placa',
    type: 'text',
    accessor: 'plate',
  },
  {
    title: 'Marca',
    type: 'text',
    accessor: 'brand',
  },
  {
    title: 'Modelo',
    type: 'text',
    accessor: 'model',
  },
  {
    title: 'Cor',
    type: 'text',
    accessor: 'color',
  },
  {
    title: 'Região',
    type: 'text',
    accessor: 'region',
  },
  {
    title: 'Cidade',
    type: 'text',
    accessor: 'city',
  },
  {
    title: 'Estado',
    type: 'text',
    accessor: 'uf',
  },
  {
    title: 'Km',
    type: 'text',
    accessor: 'km',
  },
];

export const averageKmTableLabels = [
  {
    title: 'Placa',
    type: 'text',
    accessor: 'plate',
  },
  {
    title: 'Marca',
    type: 'text',
    accessor: 'brand',
  },
  {
    title: 'Modelo',
    type: 'text',
    accessor: 'model',
  },
  {
    title: 'Data de Entrada',
    type: 'text',
    accessor: 'deliveryDate',
  },
  {
    title: 'Prazo Contratual',
    type: 'text',
    accessor: 'contractDeadline',
  },
  {
    title: 'Km Ult Passagem',
    type: 'text',
    accessor: 'lastRevisionKm',
  },
  {
    title: 'Data Ult Passagem',
    type: 'text',
    accessor: 'lastTicketDate',
  },
  {
    title: 'Km Médio',
    type: 'text',
    accessor: 'averageKm',
  },
];

// -------------------------------------------------------------------------------------
